import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import VerticalDots from '../../assets/dashboard/VerticalDots';
import './VerticalDotsDropdown.scss';

const VerticalDotsDropdown = ({
  options,
  className,
  setOpenDropdown,
  openDropdown,
  disabled = false,
}) => {
  const triggerRef = useRef();
  const dropdownRef = useRef();
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (openDropdown && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const dropdownWidth = 192;

      setDropdownPosition({
        top: rect.bottom + window.scrollY + 4,
        left: rect.right + window.scrollX - dropdownWidth,
      });
    }
  }, [openDropdown]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target)
      ) {
        setOpenDropdown(false);
      }
    };

    if (openDropdown) {
      document.addEventListener('click', handleClickOutside, true);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [openDropdown, setOpenDropdown]);

  return (
    <>
      <div ref={triggerRef} className="rounded font-weight-bold non-selectable">
        <div
          onClick={() => {
            if (!disabled) {
              setOpenDropdown(!openDropdown);
            }
          }}
          aria-hidden
          className={`mx-2 d-flex vertical-dots-trigger ${
            disabled ? 'cursor-not-allowed' : 'cursor-pointer'
          }`}
          disabled={disabled}
        >
          <VerticalDots className="menu-dots" />
        </div>
      </div>

      {openDropdown &&
        createPortal(
          <ul
            ref={dropdownRef}
            className={`vertical-dots-dropdown bg-white m-0 py-2 ${className}`}
            style={{
              position: 'absolute',
              top: `${dropdownPosition.top}px`,
              left: `${dropdownPosition.left}px`,
              zIndex: 1050,
            }}
          >
            {options.map((item) => (
              <li
                data-testid={`li-${item.testid}`}
                key={item.testid}
                className={`py-1 px-2 w-100 cursor-pointer ${item.itemClass}`}
              >
                {item.customContent ? (
                  item.customContent
                ) : (
                  <button
                    disabled={item.disabled}
                    data-testid={item.testid}
                    className="dropdown-btn d-flex align-items-center border-0 px-2 w-100 bg-transparent"
                    onClick={(e) => {
                      if (item.action) {
                        item.action();
                      }
                      setOpenDropdown(false);
                    }}
                    type="button"
                  >
                    <div className="row no-gutters w-100 justify-content-start align-items-center">
                      <div className="col-2">{item.icon}</div>
                      <div className="col-10">
                        <span className="pl-1 font-weight-500">{item.text}</span>
                      </div>
                    </div>
                  </button>
                )}
              </li>
            ))}
          </ul>,
          document.body
        )}
    </>
  );
};

export default VerticalDotsDropdown;
